import { type ReactElement, type ReactNode } from 'react';
import { CLONE_TABLE_PANEL_HEADER_HEIGHT } from '@/features/shared/components/cloneTable/cloneTableConstants';
import { Panel } from '@/ui/composites/Panel';
import { Stack } from '@/ui/layout/Stack';
import { Box, Tab, Tabs } from '@/ui/primitives';

type DetailCloneTablePanelProps = {
  tabLabel: string;
  tabsAriaLabel: string;
  toolbarSlot?: ReactNode;
  actionsSlot?: ReactNode;
  children: ReactNode;
};

export const DetailCloneTablePanel = ({
  tabLabel,
  tabsAriaLabel,
  toolbarSlot,
  actionsSlot,
  children,
}: DetailCloneTablePanelProps): ReactElement => (
  <Panel
    padding="md"
    gap="none"
    contentGap="md"
    headerGap="none"
    headerSlot={
      <Box
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          minHeight: `${CLONE_TABLE_PANEL_HEADER_HEIGHT}px`,
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          gap="md"
          sx={{
            minWidth: 0,
            minHeight: `${CLONE_TABLE_PANEL_HEADER_HEIGHT}px`,
            height: `${CLONE_TABLE_PANEL_HEADER_HEIGHT}px`,
          }}
        >
          <Box sx={{ minWidth: 0, flex: '1 1 auto' }}>
            <Tabs value={tabLabel} aria-label={tabsAriaLabel}>
              <Tab
                label={tabLabel}
                value={tabLabel}
                disableRipple
                sx={{
                  cursor: 'default',
                  pointerEvents: 'none',
                }}
              />
            </Tabs>
          </Box>
          {toolbarSlot || actionsSlot ? (
            <Stack direction="row" alignItems="center" gap="md" sx={{ flex: '0 0 auto' }}>
              {actionsSlot}
              {toolbarSlot}
            </Stack>
          ) : null}
        </Stack>
      </Box>
    }
    sx={{ backgroundColor: 'background.paper' }}
  >
    {children}
  </Panel>
);
